'use strict';

var TrackingLayer = require('./modules/module.tracking-layer').default,
    bornUtils = require('./helpers/born.utils'),
	ajax = require('./ajax')

/**
 * Sets the locale cookie by getting the selected index's data-locale.
 */
function setLocaleCookie(localeValue) {

    bornUtils.createCookie('preferredLocale', localeValue, 365);
}

exports.init = function init () {

    // set country and currency first before reloading the page
    $('.country-selector__save').on('click', function (e) {
        var trigger = this,
            countries   = document.querySelector(this.getAttribute('data-context') + ' .country-selector__list'),
            languages   = $('.languageSelectorList'),
            country     = countries.options[countries.selectedIndex].getAttribute('data-country'),
            url         = countries.value,
            pipeline    = Urls.setSessionCountryAndCurrency;

        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCountryAndCurrency,
            data: {
                format: 'ajax',
                countryCode: country
            }
        })
        .done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set country/currency');
            }

            //Assing the url refresh into a different locale only if said locale is not the current.
                url = languages.data('value');

                setLocaleCookie(languages.data('locale'));

            if(trigger.getAttribute('data-context') === '.modal--welcomemat__sett') {
                TrackingLayer.pushData('alternative_countryselect: ' + window.Resources['TRUE_STRING']);
                TrackingLayer.pushData('alternative_country_selected: ' + country);
            }

            else {
                TrackingLayer.pushData('curency_changed: ' + window.Resources['TRUE_STRING']);
            }
            
            sessionStorage.clear();

            window.location.href = url;
        });
    });
    if ($('#countrySelectorList').length>0) {
        var countryCode = $('#countrySelectorList').find(":selected").data('country').toLowerCase();
        $('#countrySelectorList').selectric({ disableOnMobile: false, nativeOnMobile: false });
        const regionText = $('#countrySelectPopUp').data('regiontext');
        $('#countrySelectPopUp').prepend(`<span id="selectricCountryFlag" class="country-${countryCode}"></span>`)
        .prepend(`<span class="region-text txt--sm-medium display--small-only">${regionText}</span>`);
        $('.country-selector').on('click', '#selectricCountryFlag', () => {
            $('.country-selector .selectric__arrow').trigger('click');
        });
    }
    //Sets the language selection inside a <select> tag.
    $('.language-selector__save').on('click', function() {
        var languages = $('.languageSelectorList');

        setLocaleCookie(languages.data('locale'));
        window.location.href = languages.data('value');
    });
};

	//Sets the language selection inside a <select> tag.
	$('.languageSelectorList').on('click', function (e) {
        e.preventDefault();
		var url=$(this).data('value');
	    var locale = $(this).data('locale');
	    setLocaleCookie(locale);

	    updateUrlFromLocale(url, locale);
	});
    
    $('.language-option:not(.selected)').on('click', function(e) {
        e.preventDefault();
        var url = $(this).attr('href');
        var locale = $(this).data('locale');
        if(locale === undefined || locale == '') {
            locale = 'en';
        }
        bornUtils.createCookie('preferredLocale', locale, 365);
        
        updateUrlFromLocale(url, locale);
    });
    
    function updateUrlFromLocale(url, newLocale)
    {
         var lastPipelineName =  $("#lastPipelineName").val();
         if(url.includes("lang=en") ){
	        if(lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm'){
	            url = Urls.cartShow;
	        }
	    	url = url.replace("lang=en","lang="+newLocale);
	    }else if(url.includes("lang=ar")){
	        if(lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm'){
	            url = Urls.cartShow;
	        }
	    	url = url.replace("lang=ar","lang="+newLocale);
	    }
	    
	    window.location.href = url;
    }
 // set country and currency when changing country dropdown
$("#countrySelectorList").change(function (e) {
        var trigger = this,
        	countries  = document.querySelector('.header__sett .country-selector__list'),
            country  = countries.options[countries.selectedIndex].getAttribute('data-country'),
            siteID     = countries.options[countries.selectedIndex].getAttribute('data-site'),
            url        = e.target.value;
            //pipeline    = Urls.setSessionCountryAndCurrency;
        	bornUtils.createCookie('preferredSite', siteID, 365);

	          $.ajax({
		          dataType: 'json',
		          url: Urls.updateUserCountry,
		          data: {
		        	  countryCode: country,
		              requestType:"ajax"
		          }
			      })
			 .done(function (response) {
             });
            $('#selectricCountryFlag')[0].className = `country-${country.toLowerCase()}`;
	        window.location.href = url;
//        $.ajax({
//            dataType: 'json',
//            url: Urls.hasRestrictedProducts,
//            data: {
//                countryCode: country,
//                requestType:"ajax"
//            }
//        })
//        .done(function (response) {
//        	if(response.hasRestrictedProducts){
//        		document.getElementById("restrictedCountryPopUpWrapper").style.display = "block";
//        		$('#countrySelectPopUp').hide();
//        	}else{
//        		document.getElementById("restrictedCountryPopUpWrapper").style.display = "none";
//        		setSessionCountryAndCurrency()
//        	}
//        });

    });

    $('#countryPopUpOk').on('click', function(){
    	var countries   = document.querySelector('.header__sett .country-selector__list');
        var country     = countries.options[countries.selectedIndex].getAttribute('data-country');

	   $.ajax({
           dataType: 'json',
           async: "false",
           data: {
               countryCode: country,
               requestType:"ajax"
           },
           type: 'POST',
           url: Urls.removeRestrictedProducts
       })
       .done(function (response) {
       });

	   setSessionCountryAndCurrency();
    });

    $('#countryPopUpCancel').on('click', function(){
    	document.getElementById("restrictedCountryPopUpWrapper").style.display = "none";
    	var countryCode = $("#currentCountryCode").val();
    	var selectedObj = $('#countrySelectorList [data-country="'+countryCode+'"]');
    	if(selectedObj.length > 0) {
    		var selectedIndex = selectedObj.index();
    		$('#countrySelectorList').prop('selectedIndex', selectedIndex).selectric('refresh');
    	}
    	$('#countrySelectPopUp').show();
    });

    function setSessionCountryAndCurrency(){
    	var countries   = document.querySelector('.header__sett .country-selector__list');
        var country     = countries.options[countries.selectedIndex].getAttribute('data-country');
        var url  = countries.value;
    	 $.ajax({
             dataType: 'json',
             url: Urls.setSessionCountryAndCurrency,
             data: {
                 format: 'ajax',
                 countryCode: country
             }
         })
         .done(function (response) {
             if (!response.success) {
                 throw new Error('Unable to set country/currency');
             }

             TrackingLayer.pushData('curency_changed: ' + window.Resources['TRUE_STRING']);

             sessionStorage.clear();
             var isGeoEnabled = SitePreferences.IS_GEO_TARGETING_ENABLED;
             var lastPipelineName =  $("#lastPipelineName").val();
             if(isGeoEnabled){
	             if(lastPipelineName == 'Product-Show'){
	            	 if(url.includes("country=")){
		            	 url = updateActionURL(url,country);
		             }else if(url.includes("?")){
	            		 url = url + "&country="+country;
	            	 }else{
		            	 url = url + "?country="+country;
		             }
	             }
	             else if(lastPipelineName == 'Search-Show' || url.includes("country=")){
	            	 if(url.includes("country=")){
		            	 url = updateActionURL(url,country);
		             }else{
		            	 if(url.includes("?")){
		            		 url = url + "&country="+country;
		            	 }
		             }
	             }
             }
             if(lastPipelineName == 'Cart-SubmitForm' || lastPipelineName == 'SGCart-SubmitForm'){
                 url = Urls.cartShow;
             }
             window.location.href = url;
         });
    }

    function updateActionURL(url,country){
    	var actionURL = url;
        if(actionURL.includes("country=")){
        	var array = actionURL.split("?");
        	if(array.length > 1){
        		for(var i=0; i < array.length; i++){
        			if(array[i].includes("&")){
        				var paramArray = array[i].split("&");
        				if(paramArray.length > 1){
        					for(var j=0; j < paramArray.length ; j++){
        						if(paramArray[j].includes("country=")){
        							var replaceParam = paramArray[j];
        							var newParam = "country="+country;
        							var url = url.replace(replaceParam, newParam);
        							return url;
        						}
        					}
        				}
        			}else if(array[i].includes("=") && array[i].includes("country=")){
        				var replaceParam = array[i];
						var newParam = "country="+country;
						var url = url.replace(replaceParam, newParam);
						return url;
        				
        			}
        		}
        	}
        }
    }



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/countries.js